import script from "./DetailModalShell.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailModalShell.vue?vue&type=script&lang=ts&setup=true"

import "./DetailModalShell.vue?vue&type=style&index=0&id=e5ae7996&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ae7996"]])

export default __exports__